import { render, staticRenderFns } from "./Educations.vue?vue&type=template&id=798c58dd&scoped=true"
import script from "./Educations.vue?vue&type=script&lang=js"
export * from "./Educations.vue?vue&type=script&lang=js"
import style0 from "./Educations.vue?vue&type=style&index=0&id=798c58dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798c58dd",
  null
  
)

export default component.exports